import {Toast, Toaster} from "react-hot-toast";
import {IconType} from "react-icons";
import {FiAlertCircle, FiCheck, FiInfo} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";

import styles from "./UptimeToaster.module.scss";

type UptimeToastProps = Omit<Toast, "icon"> & {icon?: IconType};

const UptimeToast = ({message, type, icon, id, ariaProps}: UptimeToastProps) => {
  const alertVariant = type === "success" ? "verification" : type === "error" ? "error" : "default";
  const alertIcon = icon ? icon : type === "success" ? FiCheck : type === "error" ? FiAlertCircle : FiInfo;

  return (
    <Alert variant={alertVariant} icon={alertIcon} dismissible key={id} {...ariaProps}>
      <>{message}</>
    </Alert>
  );
};

export const UptimeToaster = () => {
  return (
    <Toaster position="top-center" containerClassName={styles.toasterContainer}>
      {(toast: Toast) => <UptimeToast {...toast} icon={toast.icon as unknown as IconType} />}
    </Toaster>
  );
};
